import { render, staticRenderFns } from "./EstimationInputMessage.vue?vue&type=template&id=af49490a&"
import script from "./EstimationInputMessage.vue?vue&type=script&lang=js&"
export * from "./EstimationInputMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports